import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const WifiOffIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <g clipPath="url(#clip0_7445_2913)">
            <path
              d="M22.425 10.85C20.9583 9.44999 19.3542 8.33332 17.6125 7.49999C15.8708 6.66665 14 6.24999 12 6.24999C11.3833 6.24999 10.7917 6.28749 10.225 6.36249C9.65833 6.43749 9.18333 6.54165 8.8 6.67499L6.975 4.84999C7.70833 4.58332 8.50417 4.37499 9.3625 4.22499C10.2208 4.07499 11.1 3.99999 12 3.99999C14.3333 3.99999 16.5292 4.48332 18.5875 5.44999C20.6458 6.41665 22.45 7.69165 24 9.27499L22.425 10.85ZM18.2 15.075C17.65 14.5417 17.15 14.1125 16.7 13.7875C16.25 13.4625 15.675 13.1417 14.975 12.825L12.15 9.99999C13.7333 10.0333 15.1292 10.3583 16.3375 10.975C17.5458 11.5917 18.6917 12.4333 19.775 13.5L18.2 15.075ZM20.125 22.275L10.275 12.425C9.375 12.6417 8.54583 12.9917 7.7875 13.475C7.02917 13.9583 6.36667 14.4917 5.8 15.075L4.225 13.5C4.84167 12.8833 5.47917 12.3417 6.1375 11.875C6.79583 11.4083 7.58333 10.9917 8.5 10.625L5.725 7.84999C4.94167 8.23332 4.2 8.68749 3.5 9.21249C2.8 9.73749 2.15833 10.2833 1.575 10.85L0 9.27499C0.6 8.65832 1.24167 8.08332 1.925 7.54999C2.60833 7.01665 3.30833 6.55832 4.025 6.17499L1.725 3.87499L2.8 2.79999L21.2 21.2L20.125 22.275ZM12 21.275L8.3 17.55C8.78333 17.0667 9.3375 16.6875 9.9625 16.4125C10.5875 16.1375 11.2667 16 12 16C12.7333 16 13.4125 16.1375 14.0375 16.4125C14.6625 16.6875 15.2167 17.0667 15.7 17.55L12 21.275Z"
              fill="#222"
            />
          </g>
          <defs>
            <clipPath id="clip0_7445_2913">
              <path fill="#fff" d="M0 0H24V24H0z" />
            </clipPath>
          </defs>
        </svg>
      </IconWrapper>
    )
  },
)
